module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAcCAYAAABoMT8aAAAABGdBTUEAALGPC/xhBQAAAAlwSFlzAAAOwwAADsMBx2+oZAAAATJJREFUSEvFlD1uwkAQhdc/d4iUW9BEKI3jG6RAUJCKIvfIGdKmSUGknMKy5RvQ00BSpIxoLAs7760GiLF3vabha3Z25Pd5ZEaoq5Bl2V2apiPWnu44Utd1kCTJO865tF6cBRJe4pxJi/z4UlgxhJXneaveCUxhsA7D8MEqkPAHzqm0DuhwFEUbo8AlzEunwDVMWoIhYdIQDA2To+CSMAnkVHjgDeEnuR6whomeIM/z26IovnTnxDfCY1uY6E0sy/IXW7XTnRM3VVXdS21EC+I43mH8Bco970IAwRLf5XwDGzR+BT7MEMrjtwF73/fneMmn3Bu09mCopCUgQySdAuIqMQqIi8QqIH2SXgGxSCZOAtIlwfJtnf4TCcfl2Cj/L1v/NzgHkzxia19ZQ/ism1dEqT+6TOg5qws48gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fanhui.png
// module id = v4Af
// module chunks = 3